import { cn } from '@/lib/utils';
import Image from 'next/image';
import Button from '../ui/Button';
import H2 from '../ui/H2';
import Link from '../ui/Link';
import P from '../ui/P';

export interface IAnimatedCard {
    imageSrc: string;
    title: string;
    text: string;
    link: string;
    className?: string;
}

export default function AnimatedCard({ title, text, link, imageSrc, className }: IAnimatedCard) {
    return (
        <div>
            <Link
                className={cn(
                    'group max-sm:max-w-full lg:max-w-[530px] w-full flex flex-col justify-between lg:pl-[60px] pl-4 gap-5 relative max-lg:min-h-[350px] lg:min-h-[478px] lg:min-w-[528px] max-lg:pl-5',
                    className,
                )}
                href={link}
            >
                <>
                    <Image
                        className="object-cover object-center group-hover:opacity-0 transition-opacity duration-500 opacity-100 brightness-75 max-lg:opacity-100"
                        src={imageSrc}
                        alt={title}
                        fill
                    />

                    <div className="flex flex-col max-lg:gap-8 lg:gap-12 z-1">
                        <H2 className="lg:pr-8 pr-4 translate-y-11 group-hover:translate-y-0 transition-all duration-500 text-white  max-lg:text-white max-lg:translate-y-5 max-lg:text-[48px] lg:text-[48px] xl:text-h3 min-h-[180px] group-hover:text-primary">
                            {title}
                        </H2>
                        <div className="w-11/12 flex flex-col max-lg:gap-8 lg:gap-12 invisible group-hover:visible opacity-0 group-hover:opacity-100 transition-all duration-300 max-lg:hidden">
                            <hr className="h-[1px] border-black w-full" />
                            <P className="leading-none">{text}</P>
                        </div>
                    </div>
                    <div className="group-hover:w-11/12 flex flex-col w-full max-lg:w-full transition-all duration-500 z-1">
                        <Button
                            className="self-end border-white group-hover:lg:border-transparent text-white  group-hover:lg:text-primary"
                            variant="arrow"
                        />
                    </div>
                </>
            </Link>
            <P className="hidden max-lg:block max-sm:max-w-full lg:max-w-[530px] w-full mt-5 max-sm:px-5">
                {text}
            </P>
        </div>
    );
}
